import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineHeadphonesIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 3A10.0002 10.0002 0 0 0 2 13v7a1 1 0 0 0 1 1h3a3 3 0 0 0 3-3v-2a3 3 0 0 0-3-3H4a8 8 0 0 1 16 0h-2a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h3a1.0001 1.0001 0 0 0 1-1v-7A10.0002 10.0002 0 0 0 12 3ZM6 15a1.0002 1.0002 0 0 1 1 1v2a1 1 0 0 1-1 1H4v-4h2Zm14 4h-2a1.0001 1.0001 0 0 1-1-1v-2a1.0001 1.0001 0 0 1 1-1h2v4Z"/>
  </SvgIcon>
}

export default LineHeadphonesIcon
